
import { API, GET, localStore, getBrandColour } from '../helpers'
import { setLoggedInUser, showHeader } from '../actions'

export const getEventDetailsFunc = (params, dispatch) => {
    return new Promise((resolve, reject) => {
        const url = API.EVENT_DETAILS_GET + params.uri
        GET(url, {}, {}, {}, false, false
        ).then(({ status, result, message }) => {
            if (status === "success") {


                const { appInfo = {} } = result;

                let brandColor = getBrandColour(result.brandColor, appInfo.color, result.saas);

                let event = {
                    id: result.id,
                    name: result.name,
                    author: result.author,
                    eventURI: result.eventURI,
                    authorURI: result.authorURI,
                    privateEvent: result.privateEvent,
                    startTime: result.startTime,
                    endTime: result.endTime,
                    description: result.description ? result.description : null,
                    speakers: result.speakers ? result.speakers : [],
                    coverImage: result.coverImage ? result.coverImage : '/assets/images/event_default_1.png',
                    coverImageSmall: result.coverImageSmall ? result.coverImageSmall : '/assets/images/event_default_1.png',
                    logo: result.logo,
                    logoSmall: result.logoSmall,
                    primaryColor: `rgb(${brandColor})`,
                    primaryColorRGB: brandColor,
                    meetId: result.meetId ? result.meetId : null,
                    conversationId: result.conversationId ? result.conversationId : null,
                    conversationSource: 'YEPDESK_LIVE',
                    isSaas: result.saas,
                    meetApp: {
                        androidLink: appInfo.androidLink ? appInfo.androidLink : null,
                        iosLink: appInfo.iosLink ? appInfo.iosLink : null,
                    },
                    saas: {
                        color: appInfo.color ? appInfo.color : '#F59211',
                        organizationName: appInfo.name ? appInfo.name : 'Organization',
                        organizationLogo: appInfo.organizationLogo ? appInfo.organizationLogo : '/assets/images/meet.png'
                    }
                }

                event.mainMenu =
                    [{
                        label: 'Home',
                        key: 'home',
                        url: '/details',
                        // isActive: true
                    },
                    // {
                    //     label: 'Video Streaming',
                    //     key: 'stream',
                    //     url: '/stream',
                    //     status: 'LIVE'

                    // }, 
                    {
                        label: 'Meeting',
                        key: 'meeting',
                        url: '/meet',
                        
                    },
                        // {
                        //     label: 'Settings',
                        //     key: 'settings',
                        //     url: '/meet',
                        // }
                    ]

                event.secondaryMenu =
                    [{
                        label: 'Chat',
                        key: 'chat',
                        //  status: 'ACTIVE',
                        statusValue: 0,
                        isActive: true
                    }, {
                        label: 'Participants',
                        key: 'participants',
                        status: 'INACTIVE'
                    },
                        // {
                        //     label: 'Polls',
                        //     key: 'polls',
                        // }
                    ]

                document.documentElement.style.setProperty('--primary', event.primaryColor);
                document.documentElement.style.setProperty('--primary-rgb', event.primaryColorRGB)

                let usersInLocalStorage = localStore.get('liveUsers')
                if (usersInLocalStorage) {
                    const currentUser = usersInLocalStorage[event.id];
                    if (currentUser && currentUser.token) {
                        dispatch(setLoggedInUser(currentUser));
                        dispatch(showHeader(true));
                    }
                }
                resolve({ status, data: event, message });
            } else if (status === "error") {
                reject({ status: "error", message: message });
            }
        })
            .catch(function (error) {
                reject(error);
            });
    });
};